export default __webpack_public_path__ + "static/wktokyo-logo-86f75475e3c407e0aebf3d42fb28f993.png";